import { Pipe, PipeTransform } from '@angular/core';
import { CultureService } from '@app/modules/core/services/culture.service';

@Pipe({ name: 'formatDate', standalone: true })
export class FormatDatePipe implements PipeTransform {
  constructor(private cultureService: CultureService) {}

  transform(value: string, format: string): string {
    if (!format) {
      format = 'LONG-DATE-WITH-TIME';
    }

    if (!value) {
      return '';
    }

    return this.cultureService.getDateDisplay(value, format);
  }
}
